import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import useHasFeature, { featureNames } from '~/shared/utils/useHasFeature';
import { mobile } from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

const StyledAiSummaryReviewWrapper = styled.div`
  width: 100%;
  display: flex;
  background-color: ${({ theme }) => theme.colors.reviewsAiSummaryBackground};
  padding: 32px;
  box-shadow: inset 0 1px 0 0
    ${({ theme }) => theme.colors.recentReviewsWrapperBoxShadow};
  flex-direction: row;
  gap: 5px;

  ${mobile`
    flex-direction: column;
    padding: 16px 0;

    ${({ $isModalItem }) =>
      $isModalItem &&
      `
      padding: 32px;
    `}
  `}

  ${({ $vertical }) =>
    $vertical &&
    `
    flex-direction: column;
    padding: 16px 0;
    gap: 0;
  `}

  ${({ $isModalItem }) =>
    $isModalItem &&
    `
      overflow: auto;
    `}

  ${({ $blockStyle }) => $blockStyle}
`;

const AiSummaryHeader = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 5px;
  width: 250px;
  ${({ $vertical }) =>
    $vertical &&
    `
    width: 100%;
  `}
`;

const AiSummaryBody = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const AiSummaryTitle = styled.p`
  font-size: 16px;
  font-weight: bold;
  ${mobile`
    font-weight: regular;
  `}
`;

const AiSummaryContent = styled.p`
  font-size: 14px;
  ${mobile`
    font-weight: regular;
  `}
`;

const ReviewAiSummary = ({ aiSummary, blockStyle, vertical, isModalItem }) => {
  const { enabled: isAiReviewSummaryEnabled } = useHasFeature(
    featureNames.AI_REVIEW_SUMMARIES
  );

  if (!isAiReviewSummaryEnabled) {
    return null;
  }

  return (
    <StyledAiSummaryReviewWrapper
      $blockStyle={blockStyle}
      $vertical={vertical}
      $isModalItem={isModalItem}
      data-testid="ai-review-summary"
    >
      <AiSummaryHeader $vertical={vertical}>
        <AiSummaryTitle>
          <FormattedMessage
            id="site_pdp.ai_summary_title"
            defaultMessage="AI Generated Review Summary"
          />
        </AiSummaryTitle>
      </AiSummaryHeader>
      <AiSummaryBody>
        <AiSummaryContent>{aiSummary}</AiSummaryContent>
      </AiSummaryBody>
    </StyledAiSummaryReviewWrapper>
  );
};

ReviewAiSummary.propTypes = {
  aiSummary: PropTypes.string.isRequired,
  blockStyle: PropTypes.any,
  isModalItem: PropTypes.bool,
  vertical: PropTypes.bool,
};

export default ReviewAiSummary;
